import { useSession } from "next-auth/react";

const authOn: boolean = process.env.NEXT_PUBLIC_AUTH_ON?.toLocaleLowerCase() === "true";

export default function useClientSideAuth() {
    useSession({ required: authOn });
}
